var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('one-catalog-view-list',{class:_vm.mainComponentClass,attrs:{"is-search":true,"listing-title-label":_vm.$t('default_seo.search'),"listing-title":_vm.listingTitle}})
}
var staticRenderFns = []

export { render, staticRenderFns }